import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {HelpContentModule} from '../../common/help-content/help-content.module';
import {HelpNavBackModule} from '../../common/help-nav-back/help-nav-back.module';
import {HelpGainContentComponent} from './help-gain-content/help-gain-content.component';
import {HelpGainComponent} from './help-gain.component';

@NgModule({
  declarations: [HelpGainComponent, HelpGainContentComponent],
  exports: [HelpGainComponent, HelpGainContentComponent],
  imports: [CommonModule, HelpContentModule, HelpNavBackModule, MatIconModule, MatTooltipModule, MatButtonModule]
})
export class HelpGainModule {}
